import React, { useEffect, useRef, useState } from "react";

// route
import { useNavigate, useParams } from "react-router";

// api
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";

// component
import ChatTrialList from "./chat-trials-list";
import ChatTrialBody from "./chat-trial-body";
import Header from "../common/header/Header";

// icon
import NoConversation from "../../assets/images/no-conversation-vector.svg";

// store
import { setCallData } from "../../reducer/slices/twilio-calls/call-slice";
import { getTrailsName } from "../../reducer/slices/trial/get-trial-name-slice";
import { useDispatch, useSelector } from "react-redux";

const ConversationPatients = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedIdRef = useRef(id);
  const isTrialsNameLoaded = useRef(false);
  const [search, setSearch] = useState("");
  const [showClose, setShowClose] = useState(false);
  const POLLING_INTERVAL = 5000; // Poll every 5 seconds
  const [selectedChatId, setSelectedChatId] = useState(id);
  const [noRecruiter, setNoRecruiter] = useState(false);
  const [trialInfo, setTrialInfo] = useState(null);
  const [trialList, setTrialList] = useState([]);
  const [mainAllTrialsName, setMainAllTrialsName] = useState([]);
  const [conversationList, setConversationList] = useState([]);
  const [latestmessage, setLatestmessage] = useState(null);
  const [currentPatientId, setCurrentPatientId] = useState(null);
  const [query, setQuery] = useState(""); // Search query
  const user = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(getTrailsName({}));
  }, []);

  const getTrialsByPatientId = async (id) => {
    const response = await axios
      .get(`${ENDPOINTS.PATIENT.GET_PATIENT_BY_ID}?patientID=${id}`)
      .then((res) => {
        setTrialList(res.data.data.patientTrialData);
        setMainAllTrialsName(res.data.data.patientTrialData);
      });
  };

  const fetchConversationData = async () => {
    try {
      axios
        .get(
          `${ENDPOINTS.CONVERSATION.GET_CONVERSATION_BY_TRIAL_ID}?patientTrialJuncId=${selectedIdRef.current}`
        )
        .then((res) => {
          if (!isTrialsNameLoaded.current) {
            setCurrentPatientId(res.data.data.patientID);
            getTrialsByPatientId(res.data.data.patientID);
          }

          isTrialsNameLoaded.current = true;

          if (res?.data?.data?.patientConversationNodes?.length > 0) {
            setConversationList(res.data.data.patientConversationNodes);
          } else {
            setConversationList([]);
          }

          setTrialInfo(res.data.data);
        })
        .catch((error) => {
          if (
            error &&
            error.response &&
            error.response.status &&
            error.response.status === 400
          ) {
            setNoRecruiter(true);
          }
          if (
            error &&
            error.response &&
            error.response.status &&
            error.response.status === 500
          ) {
            setNoRecruiter(true);
          }
        });
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.status &&
        error.response.status === 401
      ) {
      } else if (
        error &&
        error.response &&
        error.response.status &&
        error.response.status === 400
      ) {
        setNoRecruiter(true);
      } else if (
        error &&
        error.response &&
        error.response.status &&
        error.response.status === 500
      ) {
        setNoRecruiter(true);
      } else {
        setNoRecruiter(false);
      }
    }
  };

  useEffect(() => {
    if (selectedChatId) {
      selectedIdRef.current = selectedChatId;
      fetchConversationData();
      navigate(`/conversation-patients/${selectedChatId}`, { replace: true });
    }
  }, [selectedChatId]);

  useEffect(() => {
    fetchConversationData();
    const interval = setInterval(() => {
      fetchConversationData();
    }, POLLING_INTERVAL); // Poll every 5 seconds

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (conversationList) {
      setLatestmessage(conversationList[conversationList.length - 1]);
    }
  }, [conversationList]);

  //Search from header

  const onSearchClick = () => {
    if (!search) {
      return;
    }

    if (search && search.length > 0) {
      let filteredRecords = mainAllTrialsName.filter((item) =>
        item.trialName.toLowerCase().includes(search.toLowerCase())
      );
      setTrialList(filteredRecords);
    } else {
      setTrialList(mainAllTrialsName);
    }
    setShowClose(true);
  };

  useEffect(() => {
    if (query && query.length > 0) {
      let filteredRecords = mainAllTrialsName.filter((item) =>
        item.trialName.toLowerCase().includes(query.toLowerCase())
      );
      setTrialList(filteredRecords);
    } else {
      setTrialList(mainAllTrialsName);
    }
  }, [query]);

  const onCloseClick = () => {
    //setAllTrialsName([...mainAllTrialsName]);
    setSearch("");
    setTrialList(mainAllTrialsName);
    setShowClose(false);
  };

  // Search as you type

  const onHandleSearch = (value) => {
    setQuery(value);
  };

  // Clear the search input and reset the list
  const clearSearch = () => {
    debugger;
    setQuery(""); // Clear the search query
    setTrialList(mainAllTrialsName);
  };

  // twilio calls

  const handleCall = async (phoneNumber) => {
    if (!phoneNumber) {
      return;
    }

    dispatch(
      setCallData({
        params: {
          To: phoneNumber,
          PatientID: trialInfo.patientID,
          PatientTrialJuncID: trialInfo.patientTrialJuncID,
          UserID: user.userProfile.userID,
        },
        trialInfo,
        call: true,
        route: `/conversation-patients/${trialInfo.patientTrialJuncID}`,
      })
    );
  };

  useEffect(() => {
    setSelectedChatId(id);
    console.log('trialInfo', trialInfo)
  }, [id]);

  return (
    <div key={selectedChatId}>
      <Header
        backbutton={true}
        headertitle={`${
          trialInfo?.patientName ? trialInfo.patientName : "Patient Name"
        } ${trialInfo?.phoneNumber ? "-" + trialInfo.phoneNumber : ""}`}
        showClose={showClose}
        isSearch={true}
        search={search}
        setSearch={setSearch}
        onSearchClick={onSearchClick}
        onCloseClick={onCloseClick}
        docuSignStatus={trialInfo?.docuSignStatus}
        // iSeclinProSync={trialInfo?.iSeclinProSync || trialInfo?.eclinProSyncStatus === "failed" ? true : false}
        // eclinProSyncStatus={trialInfo?.eclinProSyncStatus}
        // eclinProSyncResult={trialInfo?.eclinProSyncResult}
      />
      {noRecruiter === true ? (
        <div className="h-[calc(100vh-80px)] w-full flex flex-col items-center justify-center no-conversation actual-img-ratio">
          <img src={NoConversation} alt="" />
          <p className="mt-1 text-sm font-medium">No Conversations yet</p>
        </div>
      ) : (
        <div className="flex flex-row justify-content h-[calc(100vh-88px)] ">
          <ChatTrialList
            trialList={trialList}
            onSelectChat={setSelectedChatId}
            selectedChatId={selectedChatId}
            trialName={trialInfo}
            lastmessage={latestmessage}
            onSearch={onHandleSearch}
            query={query}
            onClear={clearSearch}
          />
          <ChatTrialBody
            handleCall={handleCall}
            setAllTrialsName={trialInfo}
            id={selectedChatId}
            trialInfo={trialInfo}
            conversation={conversationList || []}
            setLatestmessage={setLatestmessage}
            onMessageSend={() => getTrialsByPatientId(currentPatientId)}
          />
        </div>
      )}
    </div>
  );
};

export default ConversationPatients;
